import { Portal } from '@angular/cdk/portal';
import { inject, Injectable } from '@angular/core';
import { OuiSlidePanelService } from 'omnium-ui/layout';
import { filter, map, Observable, tap } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class FiltrerInvestisseursPanelService {
  public readonly viewerClosed$: Observable<void>;
  private slidePanelService = inject(OuiSlidePanelService);

  private opened: boolean = false;

  private filterPortal: Portal<any> | null = null;

  constructor() {
    this.viewerClosed$ = this.slidePanelService.slidePanelState$.pipe(
      filter(state => state === 'closed' && this.opened),
      tap(() => this.onPanelClose()),
      map(() => void 0)
    );
  }

  public registerPortal(portal: Portal<any>) {
    this.filterPortal = portal;
  }

  public openFilterPanel() {
    if (!this.filterPortal) {
      throw new Error(`No portal registered in FiltrerInvestisseursPanelService. Please register a portal using registerPortal.`);
    }
    this.slidePanelService.setSlidePanelContent(this.filterPortal);
    this.slidePanelService.openSlidePanel({ position: 'right', autoFocus: false, disableClose: false });

    this.opened = true;
  }

  public closeFilterPanel() {
    this.slidePanelService.setSlidePanelContent(null);
    this.slidePanelService.closeSlidePanel();
  }

  private onPanelClose() {
    this.slidePanelService.setSlidePanelContent(null);
    this.opened = false;
  }
}
